import { 
    purchaseAPI, 
    supplierAPI, 
    productAPI, 
    masterAPI,
    inventoryAPI
} from './api';

// Purchase Actions with Complete Business Logic
export const purchaseActions = {
    // Get suppliers with proper error handling
    getSuppliers: async () => {
        try {
            const response = await supplierAPI.getAll();
            debugger;
            // Handle different response structures
            if (response.success && response.data) {
                return { 
                    success: response.success, 
                    data: response.data
                };
            } 
            
            return { success: false, message: 'No suppliers found', data: [] };
        } catch (error) {
            console.error('Error fetching suppliers:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to fetch suppliers',
                data: []
            };
        }
    },

   // In your PurchaseAction.js, update the createPurchase function:

// Create purchase with complete business logic

createPurchase: async (purchaseData) => {
    try {
        // Validate required fields
        if (!purchaseData.supplier_id) {
            return { success: false, message: 'Supplier is required' };
        }
        
        if (!purchaseData.reference_no) {
            return { success: false, message: 'Reference number is required' };
        }
        
        // Parse items if they're in string format
        let items = purchaseData.items;
        if (typeof items === 'string') {
            try {
                items = JSON.parse(items);
            } catch (e) {
                return { success: false, message: 'Invalid items format' };
            }
        }
        
        if (!items || items.length === 0) {
            return { success: false, message: 'At least one item is required' };
        }
        
        // Validate each item
        for (const item of items) {
            if (!item.product_name || item.product_name.trim() === '') {
                return { success: false, message: 'Product name is required for all items' };
            }
            
            if (!item.quantity || parseFloat(item.quantity) <= 0) {
                return { success: false, message: 'Valid quantity is required' };
            }
            
            if (!item.unit_price || parseFloat(item.unit_price) <= 0) {
                return { success: false, message: 'Valid unit price is required' };
            }
        }
        
        // FIX: Send items as array (not string) to PHP
        const purchaseDataToSend = {
            ...purchaseData,
            items: items  // Send as array, PHP will handle JSON parsing
        };
        
        debugger;
        const response = await purchaseAPI.create(purchaseDataToSend);
        debugger;
        
        if (response && (response.success || response.status || response.id)) {
            const purchaseId = response.id || response.data?.id || response.purchase_id;
            
            if (!purchaseId) {
                return { success: false, message: 'Purchase created but no ID returned' };
            }
            
            // REMOVED: The loop that creates items again
            
            return { 
                success: true, 
                data: {
                    ...response,
                    id: purchaseId,
                    items: items // Return the items we sent
                },
                message: 'Purchase created successfully'
            };
        } else {
            return { 
                success: false, 
                message: response?.message || 'Failed to create purchase' 
            };
        }
    } catch (error) {
        console.error('Error creating purchase:', error);
        return { 
            success: false, 
            message: error.response?.data?.message || 'Failed to create purchase' 
        };
    }
},

    // Get purchases list with filters and pagination
     getPurchases: async (params = {}) => {
        try {
            const response = await purchaseAPI.list(params);
            console.log('Raw API response:', response);
            
            // Your API returns { purchases: [...], total: 14, page: 1, ... }
            debugger;
            if (response.data.purchases) {
                return {
                    success: response.status || true,
                    data: response.data.purchases,
                    total: response.data.total,
                    page: response.data.page,
                    limit: response.data.limit,
                    totalPages: response.data.total_pages,
                    message: 'Purchases fetched successfully'
                };
            } else {
                return {
                    success: false,
                    message: 'Invalid API response format',
                    data: []
                };
            }
        } catch (error) {
            console.error('Error fetching purchases:', error);
            return {
                success: false,
                message: error.message || 'Failed to fetch purchases',
                data: []
            };
        }
    },

    // In your purchaseActions.js, update the getPurchase function:

// In purchaseActions.js - SIMPLIFIED VERSION
getPurchase: async (id) => {
    try {
        const response = await purchaseAPI.get(id);
        debugger;
        if (!response) {
            return { success: false, message: 'Purchase not found' };
        }
        
        // Handle response structure
        if (response.success && response.data) {
            return { 
                success: true, 
                data: response.data
            };
        } else if (response.data) {
            return { 
                success: true, 
                data: response.data
            };
        } else {
            return { 
                success: true, 
                data: response
            };
        }
    } catch (error) {
        console.error('Error fetching purchase:', error);
        return { 
            success: false, 
            message: error.response?.data?.message || 'Failed to fetch purchase' 
        };
    }
},
   // Update purchase with complete business logic including stock management
updatePurchase: async (id, purchaseData) => {
  try {
    // Validate ID
    if (!id) {
      return { success: false, message: 'Purchase ID is required' };
    }
    
    // Add ID to purchaseData
    purchaseData.id = id;
    
    // Get existing purchase to manage stock properly
    const existingPurchaseResponse = await purchaseAPI.get(id);
    if (!existingPurchaseResponse || !existingPurchaseResponse.data) {
      return { success: false, message: 'Purchase not found' };
    }
    
    const existingPurchase = existingPurchaseResponse.data;
    
    // Parse items if they're in string format
    let newItems = purchaseData.items;
    if (typeof newItems === 'string') {
      try {
        newItems = JSON.parse(newItems);
      } catch (e) {
        return { success: false, message: 'Invalid items format' };
      }
    }
    
    if (!newItems || newItems.length === 0) {
      return { success: false, message: 'At least one item is required' };
    }
    
    // Get existing items from the purchase
    let existingItems = [];
    if (existingPurchase.items && Array.isArray(existingPurchase.items)) {
      existingItems = existingPurchase.items;
    } else {
      // Try to get items separately
      try {
        const itemsResponse = await purchaseAPI.getItems(id);
        if (itemsResponse && Array.isArray(itemsResponse)) {
          existingItems = itemsResponse;
        } else if (itemsResponse && itemsResponse.data) {
          existingItems = itemsResponse.data;
        }
      } catch (itemsError) {
        console.error('Error fetching existing items:', itemsError);
      }
    }
    
    // Create a map of existing items by product_id
    const existingItemsMap = new Map();
    existingItems.forEach(item => {
      if (item.product_id) {
        existingItemsMap.set(item.product_id, {
          quantity: parseFloat(item.quantity) || 0,
          purchase_item_id: item.id
        });
      }
    });
    
    // Create a map of new items by product_id
    const newItemsMap = new Map();
    newItems.forEach(item => {
      if (item.product_id) {
        newItemsMap.set(item.product_id, {
          quantity: parseFloat(item.quantity) || 0,
          item: item
        });
      }
    });
    
    // Calculate stock adjustments
    const stockAdjustments = [];
    
    // Check products that were removed or quantity decreased
    existingItemsMap.forEach((existingItem, productId) => {
      const newItem = newItemsMap.get(productId);
      const existingQty = existingItem.quantity;
      const newQty = newItem ? newItem.quantity : 0;
      
      if (newQty < existingQty) {
        // Quantity decreased - subtract from stock
        const adjustment = existingQty - newQty;
        stockAdjustments.push({
          product_id: productId,
          adjustment: -adjustment, // Negative for subtraction
          type: 'purchase_update_decrease',
          reference: `PUR-UPDATE-${id}`,
          note: `Purchase update: Quantity decreased from ${existingQty} to ${newQty}`
        });
      }
    });
    
    // Check products that were added or quantity increased
    newItemsMap.forEach((newItem, productId) => {
      const existingItem = existingItemsMap.get(productId);
      const newQty = newItem.quantity;
      const existingQty = existingItem ? existingItem.quantity : 0;
      
      if (newQty > existingQty) {
        // Quantity increased - add to stock
        const adjustment = newQty - existingQty;
        stockAdjustments.push({
          product_id: productId,
          adjustment: adjustment, // Positive for addition
          type: 'purchase_update_increase',
          reference: `PUR-UPDATE-${id}`,
          note: `Purchase update: Quantity increased from ${existingQty} to ${newQty}`
        });
      }
    });
    
    // Prepare purchase data for update
    const purchaseDataToSend = {
      ...purchaseData,
      items: newItems,
      stock_adjustments: stockAdjustments // Send stock adjustments to backend
    };
    
    debugger;
    const response = await purchaseAPI.update(id, purchaseDataToSend);
    debugger;
    
    if (response && (response.success || response.status || response.id)) {
      // Apply stock adjustments after successful update
      if (stockAdjustments.length > 0) {
        for (const adjustment of stockAdjustments) {
          try {
            await inventoryAPI.adjustStock({
              product_id: adjustment.product_id,
              quantity: adjustment.adjustment,
              type: adjustment.type,
              reference_no: adjustment.reference,
              notes: adjustment.note
            });
          } catch (stockError) {
            console.error('Error adjusting stock after update:', stockError);
            // Continue even if stock adjustment fails
          }
        }
      }
      debugger;
      return { 
        success: true, 
        data: {
          ...response,
          id: id
        },
        message: 'Purchase updated successfully'
      };
    } else {
      return { 
        success: false, 
        message: response?.message || 'Failed to update purchase' 
      };
    }
  } catch (error) {
    console.error('Error updating purchase:', error);
    return { 
      success: false, 
      message: error.response?.data?.message || 'Failed to update purchase' 
    };
  }
},


    // Delete purchase with business rules
deletePurchase: async (deleteData) => {
  try {
    // Validate ID
    if (!deleteData.id) {
      return { success: false, message: 'Purchase ID is required' };
    }
    
    const response = await purchaseAPI.delete(deleteData);
    
    if (response && (response.success || response.status || response.deleted)) {
      return { 
        success: true, 
        data: response,
        message: response.message || 'Purchase deleted successfully'
      };
    } else {
      return { 
        success: false, 
        message: response?.message || 'Failed to delete purchase' 
      };
    }
  } catch (error) {
    console.error('Error deleting purchase:', error);
    return { 
      success: false, 
      message: error.response?.data?.message || 'Failed to delete purchase' 
    };
  }
},
    
    // Create purchase item
    createItem: async (itemData) => {
        try {
            const response = await purchaseAPI.createItem(itemData);
            return { 
                success: true, 
                data: response,
                message: 'Item added successfully'
            };
        } catch (error) {
            console.error('Error creating purchase item:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to create item' 
            };
        }
    },
    
    // Update purchase item
    updateItem: async () => {
        return { 
            success: false, 
            message: 'Use delete and add new item instead' 
        };
    },
    
    // Delete purchase item
    deleteItem: async (id, purchaseId) => {
        try {
            // Get item first to reverse stock
            const purchase = await purchaseActions.getPurchase(purchaseId);
            if (purchase.success && purchase.data.items) {
                const item = purchase.data.items.find(i => i.id == id);
                if (item && item.product_id) {
                    // Reverse stock
                    await inventoryAPI.adjustStock({
                        product_id: item.product_id,
                        quantity: -item.quantity, // Negative to reverse
                        type: 'item_removal',
                        reference_no: `ITEM-REM-${id}`,
                        notes: `Item removed from purchase ${purchaseId}`
                    });
                }
            }
            
            const response = await purchaseAPI.deleteItem(id);
            return { 
                success: true, 
                data: response,
                message: 'Item deleted successfully'
            };
        } catch (error) {
            console.error('Error deleting purchase item:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to delete item' 
            };
        }
    },
    
    // Update stock
    updateStock: async (stockData) => {
        try {
            const response = await inventoryAPI.updateStockPurchase(stockData);
            return { 
                success: true, 
                data: response,
                message: 'Stock updated successfully'
            };
        } catch (error) {
            console.error('Error updating stock:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to update stock' 
            };
        }
    },
    
    // Receive purchase (update status to received)
    receivePurchase: async (id) => {
        try {
            const response = await purchaseAPI.update(id, { status: 'received' });
            return { 
                success: true, 
                data: response,
                message: 'Purchase marked as received'
            };
        } catch (error) {
            console.error('Error receiving purchase:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to receive purchase' 
            };
        }
    },
    
    // Update payment status
    updatePaymentStatus: async (id, paymentStatus, paidAmount = 0) => {
        try {
            const updateData = {
                payment_status: paymentStatus,
                paid_amount: paidAmount
            };
            
            if (paymentStatus === 'paid') {
                // If marked as paid, set due_amount to 0
                const purchase = await purchaseActions.getPurchase(id);
                if (purchase.success) {
                    updateData.due_amount = 0;
                    updateData.paid_amount = purchase.data.grand_total || 0;
                }
            }
            
            const response = await purchaseAPI.update(id, updateData);
            return { 
                success: true, 
                data: response,
                message: 'Payment status updated'
            };
        } catch (error) {
            console.error('Error updating payment status:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to update payment status' 
            };
        }
    },

    // Add this to your purchaseActions.js file

// Get payment history with pagination
getPaymentHistory: async (purchaseId, page = 1, limit = 10) => {
    try {
        const response = await purchaseAPI.getPaymentHistory(purchaseId, page, limit);
        
        if (response.success) {
            return {
                success: true,
                data: response.data
            };
        }
        return {
            success: false,
            message: response.message || 'Failed to fetch payment history',
            data: { payments: [], summary: null, purchase: null, pagination: { total: 0 } }
        };
    } catch (error) {
        console.error('Error fetching payment history:', error);
        return {
            success: false,
            message: error.message || 'Failed to fetch payment history',
            data: { payments: [], summary: null, purchase: null, pagination: { total: 0 } }
        };
    }
},

// Add payment to purchase
addPayment: async (paymentData) => {
    try {
        const response = await purchaseAPI.addPayment(paymentData);
        
        if (response.success) {
            return {
                success: true,
                data: response.data,
                message: 'Payment added successfully'
            };
        }
        return {
            success: false,
            message: response.message || 'Failed to add payment'
        };
    } catch (error) {
        console.error('Error adding payment:', error);
        return {
            success: false,
            message: error.message || 'Failed to add payment'
        };
    }
},

// In purchaseActions.js
deletePayment: async (paymentId) => {
    try {
        const response = await purchaseAPI.deletePayment(paymentId);
        
        if (response && response.success) {
            return {
                success: true,
                data: response.data,
                message: 'Payment deleted successfully'
            };
        }
        return {
            success: false,
            message: response?.message || 'Failed to delete payment'
        };
    } catch (error) {
        console.error('Error deleting payment:', error);
        return {
            success: false,
            message: error.message || 'Failed to delete payment'
        };
    }
}
};

// Product Actions for Purchase with Complete Business Logic
export const purchaseProductActions = {
    // Search products with robust error handling
    searchProducts: async (searchTerm) => {
        try {
            if (!searchTerm || searchTerm.length < 2) {
                return { success: true, data: [] };
            }
            
            const response = await productAPI.search(searchTerm);
            debugger;
            // Handle different response structures
            let products = [];
            if (Array.isArray(response)) {
                products = response;
            } else if (response && Array.isArray(response.data)) {
                products = response.data;
            } else if (response && response.products) {
                products = response.products;
            }
            
            // Format for dropdown
            const formattedProducts = products.map(product => ({
                value: product.id,
                label: `${product.product_name} (${product.sku || 'N/A'}) - ₹${product.selling_price || product.price || 0}`,
                product_name: product.product_name,
                sku: product.sku,
                cost_price: parseFloat(product.cost_price) || parseFloat(product.purchase_price) || 0,
                purchase_price: parseFloat(product.purchase_price) || parseFloat(product.price) || 0,
                selling_price: parseFloat(product.selling_price) || parseFloat(product.price) || 0,
                tax_rate: parseFloat(product.tax_rate) || 0,
                category_id: product.category_id,
                brand_id: product.brand_id,
                unit_id: product.unit_id,
                quantity: parseFloat(product.quantity) || 0,
                mrp: parseFloat(product.mrp) || 0,
                status: product.status
            }));
            console.log('Formatted products for dropdown:', formattedProducts);
            return { 
                success: true, 
                data: formattedProducts,
                message: 'Products found'
                
            };
        } catch (error) {
            console.error('Error searching products:', error);
            
            // Fallback: Try to get all products and filter
            try {
                const allProducts = await productAPI.getAllForDropdown();
                let allProductsData = [];
                
                if (Array.isArray(allProducts)) {
                    allProductsData = allProducts;
                } else if (allProducts && Array.isArray(allProducts.data)) {
                    allProductsData = allProducts.data;
                }
                
                const filtered = allProductsData.filter(product => 
                    product.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    product.sku?.toLowerCase().includes(searchTerm.toLowerCase())
                ).slice(0, 50); // Limit results
                
                const formatted = filtered.map(product => ({
                    value: product.id,
                    label: `${product.product_name} (${product.sku || 'N/A'})`,
                    product_name: product.product_name,
                    sku: product.sku,
                    purchase_price: parseFloat(product.purchase_price) || parseFloat(product.cost_price) || 0,
                    cost_price: parseFloat(product.cost_price) || parseFloat(product.purchase_price) || 0,
                    tax_rate: 0, // Default
                    category_id: product.category_id,
                    brand_id: product.brand_id,
                    unit_id: product.unit_id
                }));
                
                return { success: true, data: formatted };
            } catch (fallbackError) {
                return { success: true, data: [] };
            }
        }
    },
    
    // Quick create product with complete validation
    addProductQuick: async (productData) => {
        try {
            // Validate required fields
            if (!productData.product_name || productData.product_name.trim() === '') {
                return { success: false, message: 'Product name is required' };
            }
            
            if (!productData.sku || productData.sku.trim() === '') {
                // Auto-generate SKU if not provided
                const timestamp = Date.now().toString(36);
                const random = Math.random().toString(36).substring(2, 6).toUpperCase();
                productData.sku = `PUR-${timestamp}-${random}`;
            }
            
            // Set default values
            const defaultProduct = {
                product_slug: productData.product_name.toLowerCase().replace(/\s+/g, '-') + '-' + Date.now(),
                item_code: `ITM${Date.now().toString(36).toUpperCase()}`,
                product_type: 'Single',
                quantity: 0,
                price: parseFloat(productData.purchase_price) || 0,
                cost_price: parseFloat(productData.cost_price) || parseFloat(productData.purchase_price) || 0,
                selling_price: parseFloat(productData.selling_price) || 
                    (parseFloat(productData.purchase_price) * 1.3).toFixed(2), // 30% markup
                mrp: ((parseFloat(productData.selling_price) || 
                    (parseFloat(productData.purchase_price) * 1.3)) * 1.1).toFixed(2), // MRP = Selling + 10%
                tax_type_id: null, // Will be set based on tax_rate
                tax_amount: 0,
                discount_type: 'Percentage',
                discount_value: 0,
                quantity_alert: 10,
                has_warranty: 0,
                has_manufacturer: 0,
                has_expiry: 0,
                status: 'active',
                created_by: productData.created_by || 'Admin',
                created_at: new Date().toISOString(),
                selling_type: 'Transactional',
                rate_type: 'retail'
            };
            
            const completeProductData = {
                ...defaultProduct,
                ...productData,
                purchase_price: parseFloat(productData.purchase_price) || 0,
                cost_price: parseFloat(productData.cost_price) || parseFloat(productData.purchase_price) || 0
            };
            
            // Try quick create first
            const response = await productAPI.quickCreate(completeProductData);
            
            if (response && (response.success || response.status || response.id)) {
                return { 
                    success: true, 
                    data: {
                        id: response.id || response.data?.id,
                        product_name: completeProductData.product_name,
                        sku: completeProductData.sku,
                        purchase_price: completeProductData.purchase_price,
                        cost_price: completeProductData.cost_price,
                        selling_price: completeProductData.selling_price,
                        mrp: completeProductData.mrp,
                        tax_rate: completeProductData.tax_rate || 0,
                        category_id: completeProductData.category_id,
                        brand_id: completeProductData.brand_id,
                        unit_id: completeProductData.unit_id
                    },
                    message: 'Product created successfully'
                };
            } else {
                // Fallback to regular create
                const regularResponse = await productAPI.create(completeProductData);
                
                if (regularResponse && (regularResponse.success || regularResponse.status || regularResponse.id)) {
                    return { 
                        success: true, 
                        data: {
                            id: regularResponse.id || regularResponse.data?.id,
                            product_name: completeProductData.product_name,
                            sku: completeProductData.sku,
                            purchase_price: completeProductData.purchase_price,
                            cost_price: completeProductData.cost_price,
                            selling_price: completeProductData.selling_price,
                            mrp: completeProductData.mrp,
                            tax_rate: completeProductData.tax_rate || 0,
                            category_id: completeProductData.category_id,
                            brand_id: completeProductData.brand_id,
                            unit_id: completeProductData.unit_id
                        },
                        message: 'Product created successfully'
                    };
                } else {
                    return { 
                        success: false, 
                        message: regularResponse?.message || 'Failed to create product' 
                    };
                }
            }
        } catch (error) {
            console.error('Error creating quick product:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to create product' 
            };
        }
    },
    
    // Update stock with validation
    updateStock: async (stockData) => {
        try {
            if (!stockData.product_id) {
                return { success: false, message: 'Product ID is required' };
            }
            
            if (!stockData.quantity) {
                return { success: false, message: 'Quantity is required' };
            }
            
            const response = await productAPI.updateStock(stockData);
            
            if (response && (response.success || response.status)) {
                return { 
                    success: true, 
                    data: response,
                    message: 'Stock updated successfully'
                };
            } else {
                // Fallback to inventory API
                const inventoryResponse = await inventoryAPI.updateStockPurchase(stockData);
                return { 
                    success: true, 
                    data: inventoryResponse,
                    message: 'Stock updated via inventory API'
                };
            }
        } catch (error) {
            console.error('Error updating stock:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to update stock' 
            };
        }
    },
    
    // Check SKU exists
    checkSkuExists: async (sku) => {
        try {
            const response = await productAPI.checkSku(sku);
            
            if (response && Array.isArray(response)) {
                return response.length > 0;
            } else if (response && response.data) {
                return response.data.length > 0;
            } else if (response && response.exists !== undefined) {
                return response.exists;
            }
            
            return false;
        } catch (error) {
            console.error('Error checking SKU:', error);
            return false;
        }
    },
    
    // Check item code exists
    checkItemCodeExists: async (itemCode) => {
        try {
            const response = await productAPI.checkItemCode(itemCode);
            
            if (response && Array.isArray(response)) {
                return response.length > 0;
            } else if (response && response.data) {
                return response.data.length > 0;
            } else if (response && response.exists !== undefined) {
                return response.exists;
            }
            
            return false;
        } catch (error) {
            console.error('Error checking item code:', error);
            return false;
        }
    },
    
    // Get master data with fallbacks
    getPurchaseMasterData: async () => {
        try {
            // Try combined endpoint first
            const response = await masterAPI.getAll();
            
            if (response && response.categories && response.brands && response.units && response.taxRates) {
                return {
                    success: true,
                    data: {
                        categories: response.categories,
                        brands: response.brands,
                        units: response.units.units,
                        taxRates: response.taxRates
                    }
                };
            }
            
            // Fetch individually if combined fails
            const [categoriesRes, brandsRes, unitsRes, taxRatesRes] = await Promise.allSettled([
                masterAPI.getCategories(),
                masterAPI.getBrands(),
                masterAPI.getUnits(),
                masterAPI.getTaxRates()
            ]);
            
            const categories = categoriesRes.status === 'fulfilled' ? 
                (categoriesRes.value.data.categories || categoriesRes.value) : [];
                 const parent_categories = categoriesRes.status === 'fulfilled' ? 
                (categoriesRes.value.data.parent_categories || categoriesRes.value) : [];
            const brands = brandsRes.status === 'fulfilled' ? 
                (brandsRes.value.data || brandsRes.value) : [];
            const units = unitsRes.status === 'fulfilled' ? 
                (unitsRes.value.data.units || unitsRes.value) : [];
            const taxRates = taxRatesRes.status === 'fulfilled' ? 
                (taxRatesRes.value.data || taxRatesRes.value) : [];
            
            return {
                success: true,
                data: {
                    categories: categories,
                    parent_categories: parent_categories,
                    brands: brands,
                    units: units,
                    taxRates: taxRates
                },
                message: 'Master data loaded with some fallbacks'
            };
        } catch (error) {
            console.error('Error fetching master data:', error);
            
            // Return empty data structure
            return {
                success: true,
                data: {
                    categories: [],
                    brands: [],
                    units: [],
                    taxRates: []
                },
                message: 'Using empty master data due to error'
            };
        }
    },
    
    // Get product by ID
    getProduct: async (id) => {
        try {
            const response = await productAPI.get(id);
            
            if (response && (response.id || response.data)) {
                const product = response.data || response;
                return {
                    success: true,
                    data: {
                        id: product.id,
                        product_name: product.product_name,
                        sku: product.sku,
                        purchase_price: parseFloat(product.purchase_price) || parseFloat(product.price) || 0,
                        cost_price: parseFloat(product.cost_price) || parseFloat(product.purchase_price) || 0,
                        selling_price: parseFloat(product.selling_price) || 0,
                        mrp: parseFloat(product.mrp) || 0,
                        tax_rate: parseFloat(product.tax_rate) || 0,
                        category_id: product.category_id,
                        brand_id: product.brand_id,
                        unit_id: product.unit_id,
                        quantity: parseFloat(product.quantity) || 0,
                        status: product.status
                    }
                };
            }
            
            return { success: false, message: 'Product not found' };
        } catch (error) {
            console.error('Error fetching product:', error);
            return { success: false, message: 'Failed to fetch product' };
        }
    }
};

export default {
    purchaseActions,
    purchaseProductActions
};